<template>
    <CTable
            v-if="data.page"
            :isLoading="isLoading"
            v-model:columns="data.columns"
            v-model:page="data.page"
            :options="data.tableOptions"
            :manages="data.manages"
            :manageExtras="data.manageExtras"
            :rowActions="data.rowActions"
            :clientSide="true"
            :canRefresh="false"
            :visibleSearch="false"
            :visibleItem="({item}) => item.refStorageLocation.isLocation === isLocation"
    ></CTable>
    <template v-if="lodash.get(data.useForm?.modelRef?.[dataTempKey], itemsKey)?.filter(d => !d.isDelete && d.refStorageLocation.isLocation === isLocation).length === 0">
        <div class="has-error" v-if="data.useForm?.validateInfos?.['refHazLicenseTemp.' + itemsKey]?.validateStatus === 'error'">
            <div class="ant-form-explain">
                {{ data.useForm?.validateInfos?.['refHazLicenseTemp.' + itemsKey]?.help }}
            </div>
        </div>
    </template>
</template>

<script>
    import { defineAsyncComponent, defineComponent, reactive } from "vue";
    import { state as stateApp } from "../../../../../app.logic";
    import { initData, isLoading } from "./haz-license-storage-location.logic";
    import lodash from "lodash";

    export default defineComponent({
        components: {
            CTable: defineAsyncComponent(() => import("../../../../../components/table/CTable")),
        },
        props: {
            menuContext: { default: () => stateApp.menuContext },
            viewOnly: { default: false },
            dataProp: {},
            itemsKey: {},
            dataTempKey: {},
            visible: { default: true },
            isLocation: { default: true },
        },
        setup(props) {
            const data = reactive({ ...props.dataProp });
            const refs = reactive({});
            initData({ props, data, refs });
            return { props, data, refs, isLoading, lodash };
        },
    });
</script>
